import { useState, useRef, useEffect } from "react";
import { db, auth as firebaseAuth, storage } from "./firebase_config";
import { signInWithEmailAndPassword, signOut as firebaseSignOut, onAuthStateChanged } from "firebase/auth";
import { collection, getDocs, query, orderBy, addDoc, updateDoc, deleteDoc, doc as firestoreDoc, serverTimestamp } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

const RESEND_API_KEY = "re_ZNcqiKLM_FfppEmfHoGQKWeq3a2uwEHRq";

const LIENS_PAIEMENT = [
  { nom: "Forfait Coup de Pouce", prix: "250€/mois", lien: "https://pay.sumup.com/b2c/QVDYREHE" },
  { nom: "Forfait Petit Budget", prix: "400€/mois", lien: "https://pay.sumup.com/b2c/Q1MFAZEB" },
  { nom: "Forfait Moyen Budget", prix: "600€/mois", lien: "https://pay.sumup.com/b2c/QWT94S68" },
  { nom: "Forfait Budget Confort", prix: "800€/mois", lien: "https://pay.sumup.com/b2c/Q5D61WTW" },
  { nom: "Forfait Budget Sérénité", prix: "1200€/mois", lien: "https://pay.sumup.com/b2c/Q081AYHF" },
  { nom: "Déclaration d'impôts", prix: "25€/h", lien: "https://pay.sumup.com/b2c/Q47OUY96" },
  { nom: "Contrat de travail", prix: "150€", lien: "https://pay.sumup.com/b2c/Q8RVRCQ0" },
  { nom: "Rédaction de statuts", prix: "150€", lien: "https://pay.sumup.com/b2c/QIMTMFGX" },
  { nom: "CGV", prix: "150€", lien: "https://pay.sumup.com/b2c/Q9MTOTIG" },
  { nom: "Prévisionnel 3 ans", prix: "650€", lien: "https://pay.sumup.com/b2c/QUDC9IBT" },
  { nom: "Étude de marché", prix: "450€", lien: "https://pay.sumup.com/b2c/QVR8SM1D" },
  { nom: "Séance de conseil 1h", prix: "30€", lien: "https://pay.sumup.com/b2c/QP9U2LLS" },
  { nom: "Contrat de prestation", prix: "150€", lien: "https://pay.sumup.com/b2c/Q366UXBH" },
  { nom: "Dossier présentation", prix: "150€", lien: "https://pay.sumup.com/b2c/QZ4VN9I9" },
  { nom: "Pack fin de contrat", prix: "175€", lien: "https://pay.sumup.com/b2c/QLUIY3ZU" },
  { nom: "Formulaires administratifs", prix: "55€", lien: "https://pay.sumup.com/b2c/QFAW1ZLF" },
  { nom: "Trame publipostage", prix: "35€", lien: "https://pay.sumup.com/b2c/QB1CF7Y9" },
  { nom: "Annonce journal légal", prix: "35€", lien: "https://pay.sumup.com/b2c/QYD3HJFS" },
  { nom: "Création espace en ligne", prix: "30€", lien: "https://pay.sumup.com/b2c/QLPS9R8C" },
  { nom: "Étude de la concurrence", prix: "250€", lien: "https://pay.sumup.com/b2c/QPS2OEO5" },
  { nom: "K-Bis au Greffe", prix: "10€", lien: "https://pay.sumup.com/b2c/QAKQLR2Y" },
  { nom: "K-Bis Chambre des Métiers", prix: "15€", lien: "https://pay.sumup.com/b2c/Q7Q01AOA" },
  { nom: "Veille téléphonique", prix: "100€/mois", lien: "https://pay.sumup.com/b2c/QCR309DB" },
];

async function envoyerEmail({ clientEmail, clientNom, service, montant, lienPaiement, rdvDate, rdvHeure }) {
  const res = await fetch("https://api.resend.com/emails", {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${RESEND_API_KEY}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      from: "CD'ASSIST CONSULTING <onboarding@resend.dev>",
      to: [clientEmail],
      subject: "✅ Votre RDV est confirmé — Lien de paiement CD'ASSIST",
      html: `
        <div style="font-family:Arial,sans-serif;max-width:600px;margin:0 auto;background:#fff;border-radius:16px;overflow:hidden;">
          <div style="background:linear-gradient(135deg,#6B2D8B,#C4006A);padding:32px;text-align:center;">
            <h1 style="color:#fff;font-size:24px;margin:0 0 8px;">CD'ASSIST CONSULTING</h1>
            <p style="color:rgba(255,255,255,0.85);margin:0;font-size:14px;">La solution administrative</p>
          </div>
          <div style="padding:36px 32px;">
            <h2 style="color:#1A0A2E;font-size:22px;margin:0 0 16px;">✅ Votre rendez-vous est confirmé !</h2>
            <p style="color:#6B7280;font-size:15px;line-height:1.7;">Bonjour <strong style="color:#1A0A2E;">${clientNom}</strong>,</p>
            <p style="color:#6B7280;font-size:15px;line-height:1.7;">Votre rendez-vous avec Cordinel Daniela est confirmé :</p>
            <div style="background:#faf7ff;border-radius:12px;padding:20px;margin:24px 0;border-left:4px solid #C4006A;">
              <p style="margin:6px 0;color:#1A0A2E;"><strong>📅 Date :</strong> ${rdvDate}</p>
              <p style="margin:6px 0;color:#1A0A2E;"><strong>🕐 Heure :</strong> ${rdvHeure}</p>
              <p style="margin:6px 0;color:#1A0A2E;"><strong>🛠️ Service :</strong> ${service}</p>
              <p style="margin:6px 0;color:#C4006A;font-size:20px;font-weight:700;"><strong>💰 Montant :</strong> ${montant}</p>
            </div>
            <p style="color:#6B7280;font-size:15px;">Pour finaliser votre commande :</p>
            <div style="text-align:center;margin:28px 0;">
              <a href="${lienPaiement}" style="display:inline-block;background:linear-gradient(135deg,#C4006A,#8B2FC9);color:#fff;text-decoration:none;padding:16px 40px;border-radius:50px;font-weight:700;font-size:16px;">💳 Payer maintenant →</a>
            </div>
            <p style="color:#9B7280;font-size:13px;text-align:center;">Ou copiez : <a href="${lienPaiement}" style="color:#C4006A;">${lienPaiement}</a></p>
            <div style="border-top:1px solid #f3e8ff;margin-top:28px;padding-top:20px;">
              <p style="color:#6B7280;font-size:14px;">Des questions ?</p>
              <p style="color:#374151;font-size:14px;">📞 0690 96 10 04 · 0690 96 50 10</p>
              <p style="color:#374151;font-size:14px;">✉️ daniela.cordinel@cd-assist.com</p>
            </div>
          </div>
          <div style="background:#1A0A2E;padding:20px 32px;text-align:center;">
            <p style="color:rgba(255,255,255,0.5);font-size:12px;margin:0;">© 2025 CD'ASSIST CONSULTING · cd-assist.com</p>
          </div>
        </div>
      `,
    }),
  });
  return res.ok;
}

function EnvoyerLienModal({ onClose }) {
  const [form, setForm] = useState({ clientNom: "", clientTel: "", clientEmail: "", rdvDate: "", rdvHeure: "", serviceIndex: 0 });
  const [copied, setCopied] = useState(false);

  const service = LIENS_PAIEMENT[form.serviceIndex];

  const getMessage = () => {
    return `Bonjour ${form.clientNom || ""},%0A%0AVoici votre lien de paiement pour le service : *${service.nom}* — ${service.prix}%0A%0A💳 Lien de paiement :%0A${service.lien}%0A%0A${form.rdvDate ? `📅 RDV le ${form.rdvDate}${form.rdvHeure ? ` à ${form.rdvHeure}` : ""}%0A%0A` : ""}Cordialement,%0ACordinel Daniela — CD'ASSIST CONSULTING%0A📞 0690 96 10 04`;
  };

  const handleWhatsApp = () => {
    const tel = form.clientTel.replace(/\s/g, "").replace(/^0/, "590");
    window.open(`https://wa.me/${tel}?text=${getMessage()}`, "_blank");
  };

  const handleCopy = () => {
    const text = `Bonjour ${form.clientNom},\n\nVoici votre lien de paiement pour : ${service.nom} — ${service.prix}\n\n💳 ${service.lien}\n\n${form.rdvDate ? `📅 RDV le ${form.rdvDate}${form.rdvHeure ? ` à ${form.rdvHeure}` : ""}\n\n` : ""}Cordinel Daniela — CD'ASSIST CONSULTING`;
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  return (
    <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(26,10,46,0.6)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div style={{ background: "#fff", borderRadius: 20, padding: "36px 32px", maxWidth: 500, width: "100%", boxShadow: "0 24px 80px rgba(107,45,139,0.2)", position: "relative", maxHeight: "90vh", overflowY: "auto" }}>
        <button onClick={onClose} style={{ position: "absolute", top: 16, right: 16, background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#9B7BB8" }}>✕</button>

        <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 26, color: "#1A0A2E", marginBottom: 24 }}>💳 Envoyer un lien de paiement</h2>

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {[
            { key: "clientNom", label: "Nom du client", placeholder: "Ex: Marie Dupont", type: "text" },
            { key: "clientTel", label: "Téléphone WhatsApp", placeholder: "Ex: 0690 00 00 00", type: "tel" },
            { key: "rdvDate", label: "Date du RDV", placeholder: "Ex: 30/04/2025", type: "text" },
            { key: "rdvHeure", label: "Heure du RDV", placeholder: "Ex: 10h00", type: "text" },
          ].map(f => (
            <div key={f.key}>
              <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#C4006A", letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 6 }}>{f.label}</label>
              <input type={f.type} placeholder={f.placeholder} value={form[f.key]} onChange={e => setForm({ ...form, [f.key]: e.target.value })}
                style={{ width: "100%", border: "1.5px solid #e5d5f5", borderRadius: 10, padding: "11px 14px", fontFamily: "'DM Sans',sans-serif", fontSize: 14, color: "#1A0A2E", background: "#faf7ff", outline: "none" }} />
            </div>
          ))}

          <div>
            <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#C4006A", letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 6 }}>Service *</label>
            <select value={form.serviceIndex} onChange={e => setForm({ ...form, serviceIndex: parseInt(e.target.value) })}
              style={{ width: "100%", border: "1.5px solid #e5d5f5", borderRadius: 10, padding: "11px 14px", fontFamily: "'DM Sans',sans-serif", fontSize: 14, color: "#1A0A2E", background: "#faf7ff", outline: "none" }}>
              {LIENS_PAIEMENT.map((s, i) => <option key={i} value={i}>{s.nom} — {s.prix}</option>)}
            </select>
          </div>

          <div style={{ background: "#faf7ff", borderRadius: 10, padding: "12px 16px", border: "1.5px solid rgba(196,0,106,0.15)" }}>
            <p style={{ fontSize: 12, color: "#9B7BB8", marginBottom: 4 }}>Lien de paiement :</p>
            <p style={{ fontSize: 13, color: "#C4006A", wordBreak: "break-all" }}>{service.lien}</p>
          </div>

          {/* Boutons d'envoi */}
          <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 4 }}>
            <button onClick={handleWhatsApp} disabled={!form.clientTel} style={{ background: "#25D366", color: "#fff", border: "none", padding: "13px", borderRadius: 50, fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: 14, cursor: form.clientTel ? "pointer" : "not-allowed", opacity: form.clientTel ? 1 : 0.6 }}>
              📱 Envoyer via WhatsApp
            </button>
            <button onClick={handleCopy} style={{ background: copied ? "rgba(16,185,129,0.1)" : "#f3e8ff", color: copied ? "#059669" : "#6B2D8B", border: "none", padding: "13px", borderRadius: 50, fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
              {copied ? "✅ Message copié !" : "📋 Copier le message"}
            </button>
            <a href={`mailto:${form.clientEmail}?subject=Lien de paiement CD'ASSIST CONSULTING&body=Bonjour ${form.clientNom},%0A%0AVoici votre lien de paiement pour : ${service.nom} — ${service.prix}%0A%0A💳 ${service.lien}%0A%0ACordinel Daniela`}
              style={{ background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", textDecoration: "none", padding: "13px", borderRadius: 50, fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: 14, textAlign: "center", display: "block" }}>
              ✉️ Ouvrir dans ma messagerie
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════
//  SYSTÈME DE CONTENU — localStorage
// ══════════════════════════════════════════════

const DEFAULT_DATA = {
  accueil: {
    tag: "Cabinet de consulting — Guadeloupe",
    titre: "Votre assistante administrative de confiance",
    description: "12 ans d'expérience au service de votre entreprise. Création de société, contrats, déclarations fiscales — je gère votre administratif.",
    stat1_valeur: "12+", stat1_label: "Ans d'expérience",
    stat2_valeur: "100%", stat2_label: "Confidentialité",
    stat3_valeur: "48h", stat3_label: "Délai de réponse",
    bouton1: "Prendre rendez-vous",
    bouton2: "Générer un document IA ✦",
  },
  apropos: {
    titre: "Cordinel Daniela",
    paragraphe1: "Après 12 ans passés en tant que responsable de la planification et de la gestion des stocks, secrétaire polyvalente et responsable administrative et comptable, j'ai décidé de créer mon cabinet de consulting.",
    paragraphe2: "Spécialisée dans le domaine administratif et dans le génie climatique, énergie, environnement et développement durable.",
    paragraphe3: "J'ai également effectué la formation de formateur occasionnel permettant de fournir des formations de qualité dans des domaines divers et variés.",
    citation: "Je m'engage à vous offrir la fiabilité, l'efficacité, la discrétion, une intervention rapide et soignée.",
    poste: "Fondatrice — CD'ASSIST CONSULTING",
    localisation: "Guadeloupe, France",
  },
  prestations: [
    { id: 1, icon: "🏢", titre: "Création d'entreprise", description: "Statuts, immatriculation, Kbis — toutes les démarches de A à Z.", prix: "Sur devis" },
    { id: 2, icon: "📋", titre: "Secrétariat administratif", description: "Rédaction de courriers, gestion des mails, classement, archivage.", prix: "À partir de 25€/h" },
    { id: 3, icon: "🧾", titre: "Déclaration d'impôts", description: "Accompagnement complet pour votre déclaration fiscale.", prix: "25€/h" },
    { id: 4, icon: "⚖️", titre: "Rédaction de contrats", description: "CDI, CDD, contrats commerciaux, CGV, NDA — conformes au droit français.", prix: "À partir de 39€" },
    { id: 5, icon: "📊", titre: "Comptabilité & Facturation", description: "Suivi comptable, établissement de factures, relances clients.", prix: "Sur devis" },
    { id: 6, icon: "🌱", titre: "Conseil ENR & Environnement", description: "Expertise en génie climatique, énergie renouvelable.", prix: "Sur devis" },
  ],
  tarifs: {
    forfaits: [
      { id: 1, nom: "Coup de Pouce", prix: "250", heures: "10h/mois", populaire: false },
      { id: 2, nom: "Petit Budget", prix: "400", heures: "16h/mois", populaire: false },
      { id: 3, nom: "Moyen Budget", prix: "600", heures: "26h/mois", populaire: true },
      { id: 4, nom: "Budget Confort", prix: "800", heures: "34h/mois", populaire: false },
      { id: 5, nom: "Budget Sérénité", prix: "1200", heures: "50h/mois", populaire: false },
    ],
    alacarte: [
      { id: 1, label: "Aide à la pré-comptabilité", prix: "150€/mois" },
      { id: 2, label: "Prévisionnel sur 3 ans", prix: "450€" },
      { id: 3, label: "Étude de marché", prix: "350€" },
      { id: 4, label: "Tarif à l'heure au cabinet", prix: "25€/h" },
      { id: 5, label: "Frais de déplacement", prix: "25€" },
    ],
  },
  contact: {
    telephone1: "0690 96 10 04",
    telephone2: "0690 96 50 10",
    email: "cdassist97190@gmail.com",
    adresse: "Guadeloupe, France",
    horaires: "Lun–Ven · 9h–18h",
    site: "www.cd-assist.com",
  },
  theme: {
    couleur1: "#C4006A",
    couleur2: "#6B2D8B",
  },
};

function getData() {
  try {
    const saved = JSON.parse(localStorage.getItem("cdassist_cms") || "{}");
    return {
      accueil: { ...DEFAULT_DATA.accueil, ...saved.accueil },
      apropos: { ...DEFAULT_DATA.apropos, ...saved.apropos },
      prestations: saved.prestations || DEFAULT_DATA.prestations,
      tarifs: {
        forfaits: saved.tarifs?.forfaits || DEFAULT_DATA.tarifs.forfaits,
        alacarte: saved.tarifs?.alacarte || DEFAULT_DATA.tarifs.alacarte,
      },
      contact: { ...DEFAULT_DATA.contact, ...saved.contact },
      theme: { ...DEFAULT_DATA.theme, ...saved.theme },
    };
  } catch { return DEFAULT_DATA; }
}

function saveData(data) { localStorage.setItem("cdassist_cms", JSON.stringify(data)); }

function Field({ label, value, onChange, multiline, type = "text", hint }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#C4006A", letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 6 }}>{label}</label>
      {hint && <p style={{ fontSize: 12, color: "#9B7BB8", marginBottom: 6 }}>{hint}</p>}
      {multiline ? (
        <textarea value={value} onChange={e => onChange(e.target.value)} rows={4}
          style={{ width: "100%", border: "1.5px solid #e5d5f5", borderRadius: 10, padding: "11px 14px", fontFamily: "'DM Sans',sans-serif", fontSize: 14, color: "#1A0A2E", background: "#faf7ff", resize: "vertical", outline: "none" }} />
      ) : (
        <input type={type} value={value} onChange={e => onChange(e.target.value)}
          style={{ width: "100%", border: "1.5px solid #e5d5f5", borderRadius: 10, padding: "11px 14px", fontFamily: "'DM Sans',sans-serif", fontSize: 14, color: "#1A0A2E", background: "#faf7ff", outline: "none" }} />
      )}
    </div>
  );
}

function SaveBar({ onSave, onReset, saved }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 32, padding: "14px 20px", background: saved ? "rgba(16,185,129,0.08)" : "#fff", borderRadius: 12, border: saved ? "1px solid rgba(16,185,129,0.3)" : "1.5px solid #e5d5f5", transition: "all .3s" }}>
      {saved
        ? <span style={{ fontSize: 14, fontWeight: 600, color: "#059669" }}>✅ Modifications sauvegardées !</span>
        : <span style={{ fontSize: 14, color: "#9B7BB8" }}>Modifiez les champs puis sauvegardez</span>}
      <div style={{ marginLeft: "auto", display: "flex", gap: 10 }}>
        <button onClick={onReset} style={{ padding: "8px 18px", borderRadius: 20, border: "1.5px solid #e5d5f5", background: "#fff", color: "#9B7BB8", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>↩ Annuler</button>
        <button onClick={onSave} style={{ padding: "8px 24px", borderRadius: 20, border: "none", background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>💾 Sauvegarder</button>
      </div>
    </div>
  );
}

const ADMIN_EMAIL = "daniela.cordinel@cd-assist.com";

const HEURES_DISPO = ["08:00","08:30","09:00","09:30","10:00","10:30","11:00","11:30","12:00","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30","17:00","17:30","18:00"];

function RdvManager({ setShowEnvoyerLien }) {
  const [rdvs, setRdvs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [showAddRdv, setShowAddRdv] = useState(false);
  const [newRdv, setNewRdv] = useState({ nom: "", email: "", tel: "", service: "Déclaration d'impôts", date: "", heure: "", message: "", source: "Hors ligne" });
  const [savingRdv, setSavingRdv] = useState(false);
  const [dispos, setDispos] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cdassist_dispos_v2") || "{}"); } catch { return {}; }
  });

  const getJoursFeries = (year) => {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    const paques = new Date(year, month - 1, day);
    const addDays = (date, days) => { const d = new Date(date); d.setDate(d.getDate() + days); return d; };
    const fmt = (d) => d.toISOString().split("T")[0];
    return {
      [fmt(new Date(year, 0, 1))]: "Jour de l'An",
      [fmt(addDays(paques, 1))]: "Lundi de Pâques",
      [fmt(new Date(year, 4, 1))]: "Fête du Travail",
      [fmt(new Date(year, 4, 8))]: "Victoire 1945",
      [fmt(addDays(paques, 39))]: "Ascension",
      [fmt(addDays(paques, 50))]: "Lundi de Pentecôte",
      [fmt(new Date(year, 4, 22))]: "Abolition de l'esclavage 🇬🇵",
      [fmt(new Date(year, 6, 14))]: "Fête Nationale",
      [fmt(new Date(year, 7, 15))]: "Assomption",
      [fmt(new Date(year, 10, 1))]: "Toussaint",
      [fmt(new Date(year, 10, 11))]: "Armistice",
      [fmt(new Date(year, 11, 25))]: "Noël",
    };
  };

  useEffect(() => { loadRdvs(); }, []);

  const loadRdvs = async () => {
    setLoading(true);
    try {
      const snap = await getDocs(query(collection(db, "rdvs"), orderBy("createdAt", "desc")));
      setRdvs(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const handleAddRdv = async () => {
    if (!newRdv.nom || !newRdv.date || !newRdv.heure) return;
    setSavingRdv(true);
    try {
      await addDoc(collection(db, "rdvs"), {
        ...newRdv,
        statut: "Confirmé",
        createdAt: serverTimestamp(),
      });
      setNewRdv({ nom: "", email: "", tel: "", service: "Déclaration d'impôts", date: "", heure: "", message: "", source: "Hors ligne" });
      setShowAddRdv(false);
      loadRdvs();
    } catch (e) { console.error(e); }
    setSavingRdv(false);
  };

  
  const saveDispos = (newDispos) => {
    setDispos(newDispos);
    localStorage.setItem("cdassist_dispos_v2", JSON.stringify(newDispos));
    localStorage.setItem("cdassist_dispos_public_v2", JSON.stringify(newDispos));
  };

  const toggleHeure = (date, heure) => {
    const current = dispos[date] || [];
    const updated = current.includes(heure) ? current.filter(h => h !== heure) : [...current, heure].sort();
    saveDispos({ ...dispos, [date]: updated });
  };

  const clearDay = (date) => {
    const newDispos = { ...dispos };
    delete newDispos[date];
    saveDispos(newDispos);
  };

  // Générer le calendrier du mois
  const getDaysInMonth = () => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const days = [];
    // Jours vides avant le 1er
    for (let i = 0; i < (firstDay === 0 ? 6 : firstDay - 1); i++) days.push(null);
    for (let i = 1; i <= daysInMonth; i++) {
      const date = `${year}-${String(month + 1).padStart(2, "0")}-${String(i).padStart(2, "0")}`;
      days.push({ day: i, date });
    }
    return days;
  };

  const moisNoms = ["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"];
  const today = new Date().toISOString().split("T")[0];

  const addToGoogleCalendar = (rdv) => {
    const date = rdv.date?.replace(/-/g, "") || "";
    const time = rdv.heure?.replace(":", "") || "0900";
    const endTime = String(parseInt(time) + 100).padStart(4, "0");
    const url = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(`RDV CD'ASSIST - ${rdv.service}`)}&dates=${date}T${time}00/${date}T${endTime}00&details=${encodeURIComponent(`Client: ${rdv.nom}\nEmail: ${rdv.email}\nTél: ${rdv.tel || "-"}\nService: ${rdv.service}`)}&add=${encodeURIComponent(rdv.email)}`;
    window.open(url, "_blank");
  };

  const days = getDaysInMonth();
  const joursFeries = getJoursFeries(currentMonth.getFullYear());

  return (
    <div className="fade-up">
      <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 36, color: "#1A0A2E", marginBottom: 8 }}>📅 Mes disponibilités</h1>
      <p style={{ fontSize: 14, color: "#9B7BB8", marginBottom: 28 }}>Cliquez sur un jour pour définir vos créneaux disponibles.</p>

      <div style={{ display: "grid", gridTemplateColumns: selectedDate ? "1fr 1fr" : "1fr", gap: 24, marginBottom: 24 }}>
        {/* Calendrier */}
        <div className="card">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
            <button onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1))}
              style={{ background: "#f3e8ff", border: "none", width: 36, height: 36, borderRadius: "50%", cursor: "pointer", fontSize: 18, color: "#6B2D8B" }}>←</button>
            <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, color: "#1A0A2E" }}>
              {moisNoms[currentMonth.getMonth()]} {currentMonth.getFullYear()}
            </h2>
            <button onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1))}
              style={{ background: "#f3e8ff", border: "none", width: 36, height: 36, borderRadius: "50%", cursor: "pointer", fontSize: 18, color: "#6B2D8B" }}>→</button>
          </div>

          {/* Jours de la semaine */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 4, marginBottom: 8 }}>
            {["Lu","Ma","Me","Je","Ve","Sa","Di"].map(j => (
              <div key={j} style={{ textAlign: "center", fontSize: 11, fontWeight: 700, color: "#9B7BB8", padding: "4px 0" }}>{j}</div>
            ))}
          </div>

          {/* Jours */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 4 }}>
            {days.map((d, i) => (
              <div key={i}>
                {d ? (
                  <button onClick={() => setSelectedDate(selectedDate === d.date ? null : d.date)}
                    title={joursFeries[d.date] || ""}
                    style={{
                      width: "100%", aspectRatio: "1", border: "none", borderRadius: 10,
                      cursor: d.date < today ? "not-allowed" : "pointer",
                      fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: 13,
                      background: selectedDate === d.date ? "linear-gradient(135deg,#C4006A,#8B2FC9)" :
                        joursFeries[d.date] ? "rgba(239,68,68,0.1)" :
                        dispos[d.date]?.length > 0 ? "rgba(16,185,129,0.15)" :
                        d.date === today ? "rgba(196,0,106,0.1)" : "#faf7ff",
                      color: selectedDate === d.date ? "#fff" :
                        joursFeries[d.date] ? "#DC2626" :
                        dispos[d.date]?.length > 0 ? "#059669" :
                        d.date < today ? "#D1D5DB" : "#1A0A2E",
                      position: "relative",
                    }}>
                    {d.day}
                    {dispos[d.date]?.length > 0 && !joursFeries[d.date] && (
                      <div style={{ position: "absolute", bottom: 3, left: "50%", transform: "translateX(-50%)", width: 4, height: 4, borderRadius: "50%", background: "#059669" }} />
                    )}
                    {joursFeries[d.date] && (
                      <div style={{ position: "absolute", bottom: 2, left: "50%", transform: "translateX(-50%)", fontSize: 8 }}>🔴</div>
                    )}
                  </button>
                ) : <div />}
              </div>
            ))}
          </div>

          <div style={{ marginTop: 16, display: "flex", gap: 12, fontSize: 12, color: "#9B7BB8", flexWrap: "wrap" }}>
            <span>🟢 Créneaux définis</span>
            <span>🟣 Jour sélectionné</span>
            <span>🔴 Jour férié</span>
          </div>
        </div>

        {/* Créneaux du jour sélectionné */}
        {selectedDate && (
          <div className="card">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 20, color: "#1A0A2E" }}>
                {new Date(selectedDate + "T12:00").toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" })}
              </h3>
              {dispos[selectedDate]?.length > 0 && (
                <button onClick={() => { clearDay(selectedDate); setSelectedDate(null); }}
                  style={{ background: "rgba(239,68,68,0.1)", color: "#DC2626", border: "none", padding: "6px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer" }}>
                  🗑️ Effacer
                </button>
              )}
            </div>
            <p style={{ fontSize: 13, color: "#9B7BB8", marginBottom: 14 }}>Sélectionne les créneaux disponibles :</p>
            {joursFeries[selectedDate] && (
              <div style={{ background: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.2)", borderRadius: 10, padding: "10px 14px", marginBottom: 14, fontSize: 13, color: "#DC2626", fontWeight: 600 }}>
                🔴 Jour férié : {joursFeries[selectedDate]} — Vous pouvez quand même définir des créneaux si vous travaillez ce jour.
              </div>
            )}
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {HEURES_DISPO.map(h => (
                <button key={h} onClick={() => toggleHeure(selectedDate, h)}
                  style={{ padding: "8px 14px", borderRadius: 20, border: "none", cursor: "pointer", fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: 13,
                    background: dispos[selectedDate]?.includes(h) ? "linear-gradient(135deg,#C4006A,#8B2FC9)" : "#f3e8ff",
                    color: dispos[selectedDate]?.includes(h) ? "#fff" : "#6B2D8B" }}>
                  {h}
                </button>
              ))}
            </div>
            {dispos[selectedDate]?.length > 0 && (
              <div style={{ marginTop: 14, padding: "10px 14px", background: "rgba(16,185,129,0.08)", borderRadius: 10, fontSize: 13, color: "#059669" }}>
                ✅ {dispos[selectedDate].length} créneau(x) visible(s) par vos clients
              </div>
            )}
          </div>
        )}
      </div>

      {/* RDV reçus */}
      <div className="card">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20, flexWrap: "wrap", gap: 12 }}>
          <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 24, color: "#1A0A2E" }}>📋 Rendez-vous</h2>
          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={() => setShowAddRdv(!showAddRdv)} style={{ background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", border: "none", padding: "9px 18px", borderRadius: 50, cursor: "pointer", fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: 13 }}>➕ Ajouter un RDV</button>
            <button onClick={loadRdvs} style={{ background: "#f3e8ff", color: "#6B2D8B", border: "none", padding: "8px 18px", borderRadius: 50, cursor: "pointer", fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: 13 }}>🔄 Actualiser</button>
          </div>
        </div>

        {/* Formulaire ajout RDV */}
        {showAddRdv && (
          <div style={{ background: "#faf7ff", borderRadius: 14, padding: "24px", marginBottom: 24, border: "2px solid rgba(196,0,106,0.2)" }}>
            <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 20, color: "#1A0A2E", marginBottom: 16 }}>➕ Nouveau rendez-vous</h3>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }} className="rdv-form-grid">
              <div>
                <label style={{ fontSize: 11, fontWeight: 700, color: "#C4006A", letterSpacing: 1.5, textTransform: "uppercase", display: "block", marginBottom: 6 }}>Nom *</label>
                <input value={newRdv.nom} onChange={e => setNewRdv({...newRdv, nom: e.target.value})} placeholder="Prénom Nom" style={{ width: "100%", border: "1.5px solid #e5d5f5", borderRadius: 10, padding: "10px 14px", fontFamily: "'DM Sans',sans-serif", fontSize: 14, outline: "none", background: "#fff" }} />
              </div>
              <div>
                <label style={{ fontSize: 11, fontWeight: 700, color: "#C4006A", letterSpacing: 1.5, textTransform: "uppercase", display: "block", marginBottom: 6 }}>Téléphone</label>
                <input value={newRdv.tel} onChange={e => setNewRdv({...newRdv, tel: e.target.value})} placeholder="0690 00 00 00" style={{ width: "100%", border: "1.5px solid #e5d5f5", borderRadius: 10, padding: "10px 14px", fontFamily: "'DM Sans',sans-serif", fontSize: 14, outline: "none", background: "#fff" }} />
              </div>
              <div>
                <label style={{ fontSize: 11, fontWeight: 700, color: "#C4006A", letterSpacing: 1.5, textTransform: "uppercase", display: "block", marginBottom: 6 }}>Email</label>
                <input value={newRdv.email} onChange={e => setNewRdv({...newRdv, email: e.target.value})} placeholder="email@exemple.com" style={{ width: "100%", border: "1.5px solid #e5d5f5", borderRadius: 10, padding: "10px 14px", fontFamily: "'DM Sans',sans-serif", fontSize: 14, outline: "none", background: "#fff" }} />
              </div>
              <div>
                <label style={{ fontSize: 11, fontWeight: 700, color: "#C4006A", letterSpacing: 1.5, textTransform: "uppercase", display: "block", marginBottom: 6 }}>Service</label>
                <select value={newRdv.service} onChange={e => setNewRdv({...newRdv, service: e.target.value})} style={{ width: "100%", border: "1.5px solid #e5d5f5", borderRadius: 10, padding: "10px 14px", fontFamily: "'DM Sans',sans-serif", fontSize: 14, outline: "none", background: "#fff" }}>
                  <option>Déclaration d'impôts</option>
                  <option>Création d'entreprise</option>
                  <option>Secrétariat administratif</option>
                  <option>Rédaction de contrats</option>
                  <option>Comptabilité & Facturation</option>
                  <option>Conseil ENR & Environnement</option>
                  <option>Autre</option>
                </select>
              </div>
              <div>
                <label style={{ fontSize: 11, fontWeight: 700, color: "#C4006A", letterSpacing: 1.5, textTransform: "uppercase", display: "block", marginBottom: 6 }}>Date *</label>
                <input type="date" value={newRdv.date} onChange={e => setNewRdv({...newRdv, date: e.target.value})} style={{ width: "100%", border: "1.5px solid #e5d5f5", borderRadius: 10, padding: "10px 14px", fontFamily: "'DM Sans',sans-serif", fontSize: 14, outline: "none", background: "#fff" }} />
              </div>
              <div>
                <label style={{ fontSize: 11, fontWeight: 700, color: "#C4006A", letterSpacing: 1.5, textTransform: "uppercase", display: "block", marginBottom: 6 }}>Heure *</label>
                <input type="time" value={newRdv.heure} onChange={e => setNewRdv({...newRdv, heure: e.target.value})} style={{ width: "100%", border: "1.5px solid #e5d5f5", borderRadius: 10, padding: "10px 14px", fontFamily: "'DM Sans',sans-serif", fontSize: 14, outline: "none", background: "#fff" }} />
              </div>
              <div>
                <label style={{ fontSize: 11, fontWeight: 700, color: "#C4006A", letterSpacing: 1.5, textTransform: "uppercase", display: "block", marginBottom: 6 }}>Source</label>
                <select value={newRdv.source} onChange={e => setNewRdv({...newRdv, source: e.target.value})} style={{ width: "100%", border: "1.5px solid #e5d5f5", borderRadius: 10, padding: "10px 14px", fontFamily: "'DM Sans',sans-serif", fontSize: 14, outline: "none", background: "#fff" }}>
                  <option>Hors ligne</option>
                  <option>WhatsApp</option>
                  <option>Téléphone</option>
                  <option>Email</option>
                  <option>Facebook</option>
                </select>
              </div>
              <div>
                <label style={{ fontSize: 11, fontWeight: 700, color: "#C4006A", letterSpacing: 1.5, textTransform: "uppercase", display: "block", marginBottom: 6 }}>Note</label>
                <input value={newRdv.message} onChange={e => setNewRdv({...newRdv, message: e.target.value})} placeholder="Note optionnelle..." style={{ width: "100%", border: "1.5px solid #e5d5f5", borderRadius: 10, padding: "10px 14px", fontFamily: "'DM Sans',sans-serif", fontSize: 14, outline: "none", background: "#fff" }} />
              </div>
            </div>
            <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
              <button onClick={handleAddRdv} disabled={savingRdv} style={{ background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", border: "none", padding: "12px 24px", borderRadius: 50, fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
                {savingRdv ? "⏳ Enregistrement..." : "✅ Enregistrer le RDV"}
              </button>
              <button onClick={() => setShowAddRdv(false)} style={{ background: "#f3e8ff", color: "#6B2D8B", border: "none", padding: "12px 20px", borderRadius: 50, fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: 14, cursor: "pointer" }}>Annuler</button>
            </div>
          </div>
        )}
        {loading ? (
          <p style={{ color: "#9B7BB8", textAlign: "center", padding: "32px" }}>Chargement...</p>
        ) : rdvs.length === 0 ? (
          <div style={{ textAlign: "center", padding: "48px" }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>📅</div>
            <p style={{ color: "#9B7BB8" }}>Aucun rendez-vous reçu pour le moment.</p>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            {rdvs.map(r => (
              <div key={r.id} style={{ background: "#faf7ff", borderRadius: 14, padding: "18px 20px", border: "1.5px solid rgba(196,0,106,0.1)" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 12 }}>
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 700, color: "#1A0A2E", marginBottom: 4 }}>{r.nom || r.email}</div>
                    <div style={{ fontSize: 13, color: "#9B7BB8" }}>📅 {r.date} à {r.heure} · 🛠️ {r.service}</div>
                    <div style={{ fontSize: 13, color: "#9B7BB8", marginTop: 2 }}>✉️ {r.email} {r.tel ? `· 📞 ${r.tel}` : ""}</div>
                    {r.source && r.source !== "Site web" && <div style={{ fontSize: 11, marginTop: 4, display: "inline-block", background: "rgba(107,45,139,0.1)", color: "#6B2D8B", padding: "2px 10px", borderRadius: 20, fontWeight: 600 }}>📲 {r.source}</div>}
                    {r.message && <div style={{ fontSize: 13, color: "#374151", marginTop: 6, fontStyle: "italic" }}>💬 "{r.message}"</div>}
                  </div>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <button onClick={() => addToGoogleCalendar(r)} style={{ background: "#4285F4", color: "#fff", border: "none", padding: "8px 16px", borderRadius: 50, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>📅 Google Calendar</button>
                    <a href={`mailto:${r.email}`} style={{ background: "#f3e8ff", color: "#6B2D8B", textDecoration: "none", padding: "8px 16px", borderRadius: 50, fontSize: 12, fontWeight: 600 }}>✉️ Répondre</a>
                    <button onClick={() => setShowEnvoyerLien(true)} style={{ background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", border: "none", padding: "8px 16px", borderRadius: 50, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>💳 Lien paiement</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function MessageCard({ m, onDelete, db }) {
  const [reply, setReply] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [showReply, setShowReply] = useState(false);
  const [statut, setStatut] = useState(m.statut || "Non lu");

  const updateStatut = async (newStatut) => {
    setStatut(newStatut);
    try {
      const { updateDoc, doc: fDoc } = await import("firebase/firestore");
      await updateDoc(fDoc(db, "messages", m.id), { statut: newStatut });
    } catch (e) { console.error(e); }
  };

  const sendReply = async () => {
    if (!reply.trim()) return;
    setSending(true);
    try {
      const { addDoc, collection, serverTimestamp } = await import("firebase/firestore");
      await addDoc(collection(db, "messages"), {
        userId: m.userId,
        userEmail: m.userEmail,
        userName: "CD'ASSIST CONSULTING",
        content: reply,
        from: "admin",
        createdAt: serverTimestamp(),
      });
      await updateStatut("Répondu");
      setReply("");
      setSent(true);
      setShowReply(false);
      setTimeout(() => setSent(false), 3000);
    } catch (e) { console.error(e); }
    setSending(false);
  };

  const statutConfig = {
    "Non lu": { bg: "rgba(239,68,68,0.1)", color: "#DC2626", emoji: "🔴" },
    "Lu": { bg: "rgba(245,158,11,0.1)", color: "#D97706", emoji: "👁️" },
    "Répondu": { bg: "rgba(16,185,129,0.1)", color: "#059669", emoji: "✅" },
  };

  return (
    <div style={{ background: "#fff", borderRadius: 14, padding: "18px 24px", boxShadow: "0 2px 10px rgba(107,45,139,0.06)", borderLeft: `4px solid ${statutConfig[statut]?.color || "#D97706"}` }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8, flexWrap: "wrap", gap: 8 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: "#1A0A2E" }}>{m.userName || m.userEmail}</div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {/* Sélecteur statut */}
          <select value={statut} onChange={e => updateStatut(e.target.value)}
            style={{ padding: "4px 10px", borderRadius: 20, border: `1.5px solid ${statutConfig[statut]?.color}`, fontSize: 11, fontWeight: 700, cursor: "pointer", background: statutConfig[statut]?.bg, color: statutConfig[statut]?.color, fontFamily: "'DM Sans',sans-serif" }}>
            <option>Non lu</option>
            <option>Lu</option>
            <option>Répondu</option>
          </select>
          <div style={{ fontSize: 12, color: "#9B7BB8" }}>{m.createdAt?.toDate?.().toLocaleDateString("fr-FR")}</div>
          <button onClick={onDelete} style={{ background: "rgba(239,68,68,0.1)", color: "#DC2626", border: "none", padding: "4px 10px", borderRadius: 20, fontSize: 12, cursor: "pointer" }}>🗑️</button>
        </div>
      </div>
      <p style={{ fontSize: 14, color: m.from === "admin" ? "#6B2D8B" : "#374151", lineHeight: 1.6, marginBottom: 12, fontStyle: m.from === "admin" ? "italic" : "normal" }}>
        {m.from === "admin" ? "↩️ Vous : " : ""}{m.content}
      </p>
      {m.from !== "admin" && (
        <>
          {!showReply ? (
            <button onClick={() => { setShowReply(true); if (statut === "Non lu") updateStatut("Lu"); }}
              style={{ background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", border: "none", padding: "8px 18px", borderRadius: 50, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
              💬 Répondre
            </button>
          ) : (
            <div style={{ marginTop: 8 }}>
              <textarea value={reply} onChange={e => setReply(e.target.value)} placeholder="Votre réponse..." rows={3}
                style={{ width: "100%", border: "1.5px solid #e5d5f5", borderRadius: 10, padding: "10px 14px", fontFamily: "'DM Sans',sans-serif", fontSize: 14, resize: "vertical", outline: "none", marginBottom: 8 }} />
              <div style={{ display: "flex", gap: 8 }}>
                <button onClick={sendReply} disabled={sending} style={{ background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", border: "none", padding: "8px 18px", borderRadius: 50, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
                  {sending ? "Envoi..." : "📤 Envoyer"}
                </button>
                <button onClick={() => setShowReply(false)} style={{ background: "#f3e8ff", color: "#6B2D8B", border: "none", padding: "8px 14px", borderRadius: 50, fontSize: 12, cursor: "pointer" }}>Annuler</button>
              </div>
              {sent && <p style={{ fontSize: 12, color: "#059669", marginTop: 6 }}>✅ Réponse envoyée !</p>}
            </div>
          )}
        </>
      )}
    </div>
  );
}

function BoutiqueAdmin() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editArticle, setEditArticle] = useState(null);
  const [form, setForm] = useState({ nom: "", description: "", prix: "", categorie: "Documents", fichier: null, lienPaiement: "" });
  const [uploading, setUploading] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => { loadArticles(); }, []);

  const loadArticles = async () => {
    setLoading(true);
    try {
      const snap = await getDocs(query(collection(db, "articles_boutique"), orderBy("createdAt", "desc")));
      setArticles(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const handleSave = async () => {
    if (!form.nom || !form.prix) return;
    setUploading(true);
    try {
      let fichierUrl = editArticle?.fichierUrl || "";
      let fichierNom = editArticle?.fichierNom || "";

      // Upload du fichier si nouveau
      if (form.fichier) {
        const storageRef = ref(storage, `boutique/${Date.now()}_${form.fichier.name}`);
        await uploadBytes(storageRef, form.fichier);
        fichierUrl = await getDownloadURL(storageRef);
        fichierNom = form.fichier.name;
      }

      const data = {
        nom: form.nom,
        description: form.description,
        prix: parseFloat(form.prix),
        categorie: form.categorie,
        lienPaiement: form.lienPaiement,
        fichierUrl,
        fichierNom,
        actif: true,
        updatedAt: serverTimestamp(),
      };

      if (editArticle) {
        await updateDoc(firestoreDoc(db, "articles_boutique", editArticle.id), data);
      } else {
        await addDoc(collection(db, "articles_boutique"), { ...data, createdAt: serverTimestamp() });
      }
      setShowForm(false);
      setEditArticle(null);
      setForm({ nom: "", description: "", prix: "", categorie: "Documents", fichier: null, lienPaiement: "" });
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
      loadArticles();
    } catch (e) { console.error(e); }
    setUploading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer cet article ?")) return;
    await deleteDoc(firestoreDoc(db, "articles_boutique", id));
    loadArticles();
  };

  const handleEdit = (article) => {
    setEditArticle(article);
    setForm({ nom: article.nom, description: article.description, prix: String(article.prix), categorie: article.categorie, fichier: null, lienPaiement: article.lienPaiement || "" });
    setShowForm(true);
  };

  const inputStyle = { width: "100%", border: "1.5px solid #e5d5f5", borderRadius: 10, padding: "11px 14px", fontFamily: "'DM Sans',sans-serif", fontSize: 14, color: "#1A0A2E", background: "#faf7ff", outline: "none", marginBottom: 14 };

  return (
    <div className="fade-up">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 28, flexWrap: "wrap", gap: 16 }}>
        <div>
          <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 36, color: "#1A0A2E", marginBottom: 4 }}>🛍️ Ma boutique</h1>
          <p style={{ fontSize: 14, color: "#9B7BB8" }}>Gérez vos documents et articles en vente.</p>
        </div>
        <button onClick={() => { setShowForm(true); setEditArticle(null); setForm({ nom: "", description: "", prix: "", categorie: "Documents", fichier: null, lienPaiement: "" }); }}
          style={{ background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", border: "none", padding: "12px 24px", borderRadius: 50, fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
          ➕ Ajouter un article
        </button>
      </div>

      {saved && <div style={{ background: "rgba(16,185,129,0.1)", color: "#059669", padding: "12px 16px", borderRadius: 10, marginBottom: 20, fontWeight: 600 }}>✅ Article sauvegardé !</div>}

      {/* Formulaire */}
      {showForm && (
        <div style={{ background: "#fff", borderRadius: 16, padding: "28px", marginBottom: 24, boxShadow: "0 4px 20px rgba(107,45,139,0.1)", border: "2px solid rgba(196,0,106,0.2)" }}>
          <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 24, color: "#1A0A2E", marginBottom: 20 }}>
            {editArticle ? "✏️ Modifier l'article" : "➕ Nouvel article"}
          </h2>

          <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#C4006A", letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 6 }}>Nom de l'article *</label>
          <input style={inputStyle} placeholder="Ex: Modèle de contrat CDI" value={form.nom} onChange={e => setForm({ ...form, nom: e.target.value })} />

          <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#C4006A", letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 6 }}>Description</label>
          <textarea style={{ ...inputStyle, resize: "vertical" }} rows={3} placeholder="Décrivez l'article..." value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} />

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            <div>
              <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#C4006A", letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 6 }}>Prix (€) *</label>
              <input style={inputStyle} type="number" placeholder="Ex: 29.99" value={form.prix} onChange={e => setForm({ ...form, prix: e.target.value })} />
            </div>
            <div>
              <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#C4006A", letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 6 }}>Catégorie</label>
              <select style={inputStyle} value={form.categorie} onChange={e => setForm({ ...form, categorie: e.target.value })}>
                <option>Documents</option>
                <option>Contrats</option>
                <option>Guides</option>
                <option>Templates</option>
                <option>Formations</option>
              </select>
            </div>
          </div>

          <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#C4006A", letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 6 }}>Lien de paiement SumUp</label>
          <input style={inputStyle} placeholder="https://pay.sumup.com/b2c/XXXXXXXX" value={form.lienPaiement} onChange={e => setForm({ ...form, lienPaiement: e.target.value })} />

          <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#C4006A", letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 6 }}>Fichier PDF à vendre</label>
          <label style={{ display: "block", border: "2px dashed rgba(196,0,106,0.3)", borderRadius: 12, padding: "20px", textAlign: "center", cursor: "pointer", background: "rgba(196,0,106,0.02)", marginBottom: 14 }}>
            <div style={{ fontSize: 28, marginBottom: 6 }}>📄</div>
            <div style={{ fontSize: 14, color: "#C4006A", fontWeight: 600 }}>{form.fichier ? form.fichier.name : editArticle?.fichierNom || "Cliquer pour ajouter le fichier PDF"}</div>
            <div style={{ fontSize: 12, color: "#9B7BB8", marginTop: 4 }}>PDF uniquement — Max 10MB</div>
            <input type="file" accept=".pdf" onChange={e => setForm({ ...form, fichier: e.target.files[0] })} style={{ display: "none" }} />
          </label>

          <div style={{ display: "flex", gap: 12 }}>
            <button onClick={handleSave} disabled={uploading} style={{ background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", border: "none", padding: "13px 28px", borderRadius: 50, fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
              {uploading ? "⏳ Sauvegarde..." : "💾 Sauvegarder"}
            </button>
            <button onClick={() => { setShowForm(false); setEditArticle(null); }} style={{ background: "#f3e8ff", color: "#6B2D8B", border: "none", padding: "13px 24px", borderRadius: 50, fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: 14, cursor: "pointer" }}>
              Annuler
            </button>
          </div>
        </div>
      )}

      {/* Liste des articles */}
      {loading ? (
        <div style={{ textAlign: "center", padding: "48px", color: "#9B7BB8" }}>Chargement...</div>
      ) : articles.length === 0 ? (
        <div style={{ background: "#fff", borderRadius: 16, padding: "48px", textAlign: "center", boxShadow: "0 2px 12px rgba(107,45,139,0.06)" }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>🛍️</div>
          <p style={{ color: "#9B7BB8", marginBottom: 20 }}>Aucun article dans votre boutique.</p>
          <p style={{ fontSize: 13, color: "#9B7BB8" }}>Cliquez sur "Ajouter un article" pour commencer !</p>
        </div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 20 }}>
          {articles.map(a => (
            <div key={a.id} style={{ background: "#fff", borderRadius: 16, padding: "24px", boxShadow: "0 2px 12px rgba(107,45,139,0.07)", border: "1.5px solid rgba(196,0,106,0.07)" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
                <span style={{ fontSize: 11, fontWeight: 700, background: "rgba(196,0,106,0.1)", color: "#C4006A", padding: "3px 10px", borderRadius: 20 }}>{a.categorie}</span>
                <div style={{ display: "flex", gap: 6 }}>
                  <button onClick={() => handleEdit(a)} style={{ background: "#f3e8ff", color: "#6B2D8B", border: "none", padding: "6px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer" }}>✏️</button>
                  <button onClick={() => handleDelete(a.id)} style={{ background: "rgba(239,68,68,0.1)", color: "#DC2626", border: "none", padding: "6px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer" }}>🗑️</button>
                </div>
              </div>
              <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 20, color: "#1A0A2E", marginBottom: 8 }}>{a.nom}</h3>
              <p style={{ fontSize: 13, color: "#6B7280", lineHeight: 1.6, marginBottom: 14 }}>{a.description}</p>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 28, fontWeight: 700, color: "#C4006A" }}>{a.prix}€</span>
                <div style={{ display: "flex", gap: 6 }}>
                  {a.fichierUrl && <span style={{ fontSize: 11, background: "rgba(16,185,129,0.1)", color: "#059669", padding: "4px 10px", borderRadius: 20, fontWeight: 600 }}>📄 PDF</span>}
                  {a.lienPaiement && <span style={{ fontSize: 11, background: "rgba(196,0,106,0.1)", color: "#C4006A", padding: "4px 10px", borderRadius: 20, fontWeight: 600 }}>💳 SumUp</span>}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function BackOffice() {
  const [auth, setAuth] = useState(false);
  const [email, setEmail] = useState(ADMIN_EMAIL);
  const [mdp, setMdp] = useState("");
  const [mdpError, setMdpError] = useState("");
  const [page, setPage] = useState("dashboard");
  const [data, setData] = useState(getData());
  const [draft, setDraft] = useState(getData());
  const [saved, setSaved] = useState(false);
  const [clients, setClients] = useState([]);
  const [declarations, setDeclarations] = useState([]);
  const [messagesClients, setMessagesClients] = useState([]);
  const [loadingData, setLoadingData] = useState(false);

  const loadFirebaseData = async (section) => {
    setLoadingData(true);
    try {
      if (section === "clients") {
        const snap = await getDocs(query(collection(db, "clients"), orderBy("derniereConnexion", "desc")));
        setClients(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      }
      if (section === "declarations") {
        const snap = await getDocs(query(collection(db, "declarations"), orderBy("createdAt", "desc")));
        setDeclarations(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      }
      if (section === "messages") {
        const snap = await getDocs(query(collection(db, "messages"), orderBy("createdAt", "desc")));
        setMessagesClients(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      }
    } catch (e) { console.error(e); }
    setLoadingData(false);
  };

  useEffect(() => {
    const unsub = onAuthStateChanged(firebaseAuth, (user) => {
      if (user && user.email === ADMIN_EMAIL) setAuth(true);
      else setAuth(false);
    });
    return unsub;
  }, []);

  const handleLogin = async () => {
    try {
      await signInWithEmailAndPassword(firebaseAuth, email, mdp);
      setAuth(true);
    } catch (e) {
      setMdpError("Email ou mot de passe incorrect.");
      setTimeout(() => setMdpError(""), 3000);
    }
  };

  const handleLogout = async () => {
    await firebaseSignOut(firebaseAuth);
    setAuth(false);
  };

  const [showEnvoyerLien, setShowEnvoyerLien] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [paramsPage, setParamsPage] = useState(null);
  const [stats, setStats] = useState({ clients: 0, messages: 0, declarations: 0, rdvs: 0, reglements: 0, nonReglements: 0 });
  const [recentActivity, setRecentActivity] = useState([]);
  const [paiements, setPaiements] = useState([]);

  const handleSave = () => { setData(draft); saveData(draft); setSaved(true); setTimeout(() => setSaved(false), 3000); };
  const handleReset = () => { setDraft(data); setSaved(false); };

  const css = `
    @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@600;700&family=DM+Sans:wght@300;400;500;600;700&display=swap');
    *{box-sizing:border-box;margin:0;padding:0;}
    body{font-family:'DM Sans',sans-serif;background:#f5f0ff;}
    ::-webkit-scrollbar{width:4px;}
    ::-webkit-scrollbar-thumb{background:#C4006A;border-radius:4px;}
    .nav-btn{display:flex;align-items:center;gap:10px;padding:11px 16px;border-radius:10px;cursor:pointer;transition:all .2s;font-size:14px;font-weight:500;color:#9B7BB8;width:100%;background:none;border:none;text-align:left;}
    .nav-btn:hover{background:rgba(196,0,106,0.08);color:#C4006A;}
    .nav-btn.active{background:linear-gradient(135deg,rgba(196,0,106,0.12),rgba(107,45,139,0.12));color:#C4006A;font-weight:600;}
    .card{background:#fff;border-radius:16px;padding:28px;box-shadow:0 2px 16px rgba(107,45,139,0.07);}
    input:focus,textarea:focus{border-color:#C4006A!important;box-shadow:0 0 0 3px rgba(196,0,106,0.08);}
    @keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
    .fade-up{animation:fadeUp .4s ease both;}
    .delete-btn{background:rgba(239,68,68,0.1);color:#DC2626;border:none;padding:6px 14px;border-radius:20px;font-size:12px;font-weight:600;cursor:pointer;}
    .add-btn{background:linear-gradient(135deg,#C4006A,#8B2FC9);color:#fff;border:none;padding:10px 22px;border-radius:20px;font-size:13px;font-weight:700;cursor:pointer;margin-top:12px;}
    @media(max-width:768px){
      .bo-sidebar{position:fixed!important;left:-260px!important;transition:left .3s!important;z-index:200!important;}
      .bo-sidebar.open{left:0!important;}
      .bo-main{margin-left:0!important;padding:80px 16px 24px!important;}
      .bo-topbar{display:flex!important;}
      .bo-overlay{display:block!important;}
      .stats-grid{grid-template-columns:repeat(2,1fr)!important;}
      .params-grid{grid-template-columns:repeat(2,1fr)!important;}
      .rdv-form-grid{grid-template-columns:1fr!important;}
      .card{padding:18px!important;}
    }
    @media(min-width:769px){
      .bo-topbar{display:none!important;}
      .bo-overlay{display:none!important;}
    }
  `;

  const NAV = [
    { id: "dashboard", icon: "📊", label: "Tableau de bord" },
    { id: "clients", icon: "👥", label: "Clients" },
    { id: "messages", icon: "💬", label: "Messages" },
    { id: "declarations", icon: "🧾", label: "Déclarations" },
    { id: "rdv", icon: "📅", label: "Disponibilités" },
    { id: "paiements", icon: "💰", label: "Règlements" },
    { id: "boutique_admin", icon: "🛍️", label: "Ma boutique" },
    { id: "params", icon: "⚙️", label: "Paramètres" },
  ];

  const loadDashboard = async () => {
    try {
      const [clientsSnap, messagesSnap, declarationsSnap, rdvsSnap, paiementsSnap] = await Promise.all([
        getDocs(collection(db, "clients")),
        getDocs(query(collection(db, "messages"), orderBy("createdAt", "desc"))),
        getDocs(query(collection(db, "declarations"), orderBy("createdAt", "desc"))),
        getDocs(query(collection(db, "rdvs"), orderBy("createdAt", "desc"))),
        getDocs(collection(db, "paiements")).catch(() => ({ docs: [] })),
      ]);
      const paiementsData = paiementsSnap.docs.map(d => ({ id: d.id, ...d.data() }));
      const reglements = paiementsData.filter(p => p.statut === "payé").length;
      const nonReglements = paiementsData.filter(p => p.statut !== "payé").length;
      setStats({ clients: clientsSnap.size, messages: messagesSnap.size, declarations: declarationsSnap.size, rdvs: rdvsSnap.size, reglements, nonReglements });
      setPaiements(paiementsData);
      const activity = [
        ...messagesSnap.docs.slice(0, 3).map(d => ({ type: "message", icon: "💬", label: `Message de ${d.data().userName || d.data().userEmail}`, date: d.data().createdAt })),
        ...declarationsSnap.docs.slice(0, 3).map(d => ({ type: "declaration", icon: "🧾", label: `Déclaration de ${d.data().userName || d.data().userEmail}`, date: d.data().createdAt })),
        ...rdvsSnap.docs.slice(0, 3).map(d => ({ type: "rdv", icon: "📅", label: `RDV ${d.data().service} — ${d.data().nom}`, date: d.data().createdAt })),
      ].sort((a, b) => (b.date?.seconds || 0) - (a.date?.seconds || 0)).slice(0, 6);
      setRecentActivity(activity);
    } catch (e) { console.error(e); }
  };

  useEffect(() => {
    if (page === "dashboard") loadDashboard();
  }, [page]);

  if (!auth) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg,#faf7ff,#fff0f7)" }}>
        <style>{css}</style>
        <div style={{ background: "#fff", borderRadius: 24, padding: 48, boxShadow: "0 24px 80px rgba(107,45,139,0.15)", maxWidth: 400, width: "100%", textAlign: "center" }}>
          <img src="/LOGO_CD_ASSIST.png" alt="Logo" style={{ width: 100, marginBottom: 20 }} />
          <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 28, color: "#1A0A2E", marginBottom: 8 }}>Back Office</h1>
          <p style={{ fontSize: 14, color: "#9B7BB8", marginBottom: 32 }}>CD'ASSIST CONSULTING — Éditeur de site</p>
          <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)}
            style={{ width: "100%", border: "1.5px solid #e5d5f5", borderRadius: 10, padding: "13px 16px", fontFamily: "'DM Sans',sans-serif", fontSize: 14, outline: "none", marginBottom: 12, background: "#faf7ff" }} />
          <input type="password" placeholder="Mot de passe" value={mdp} onChange={e => setMdp(e.target.value)} onKeyDown={e => e.key === "Enter" && handleLogin()}
            style={{ width: "100%", border: mdpError ? "1.5px solid #DC2626" : "1.5px solid #e5d5f5", borderRadius: 10, padding: "13px 16px", fontFamily: "'DM Sans',sans-serif", fontSize: 14, outline: "none", marginBottom: 12, background: "#faf7ff" }} />
          {mdpError && <p style={{ fontSize: 13, color: "#DC2626", marginBottom: 12 }}>❌ {mdpError}</p>}
          <button onClick={handleLogin} style={{ width: "100%", background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", border: "none", padding: "14px", borderRadius: 50, fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: 15, cursor: "pointer" }}>
            Se connecter
          </button>
          <p style={{ fontSize: 12, color: "#9B7BB8", marginTop: 20 }}>Connexion réservée à Cordinel Daniela</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f5f0ff" }}>
      <style>{css}</style>

      {showEnvoyerLien && <EnvoyerLienModal onClose={() => setShowEnvoyerLien(false)} />}

      {/* Overlay mobile */}
      {menuOpen && <div className="bo-overlay" onClick={() => setMenuOpen(false)} style={{ position: "fixed", inset: 0, background: "rgba(26,10,46,0.5)", zIndex: 199 }} />}

      {/* Topbar mobile */}
      <div className="bo-topbar" style={{ position: "fixed", top: 0, left: 0, right: 0, height: 60, background: "#fff", zIndex: 198, boxShadow: "0 2px 12px rgba(107,45,139,0.08)", padding: "0 16px", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <img src="/LOGO_CD_ASSIST.png" alt="Logo" style={{ width: 36 }} />
          <span style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 16, fontWeight: 700, color: "#6B2D8B" }}>Back Office</span>
        </div>
        <button onClick={() => setMenuOpen(!menuOpen)} style={{ background: "none", border: "none", cursor: "pointer", padding: 8, display: "flex", flexDirection: "column", gap: 5 }}>
          <div style={{ width: 22, height: 2, background: "#6B2D8B", borderRadius: 2 }} />
          <div style={{ width: 22, height: 2, background: "#6B2D8B", borderRadius: 2 }} />
          <div style={{ width: 22, height: 2, background: "#6B2D8B", borderRadius: 2 }} />
        </button>
      </div>

      <aside className={`bo-sidebar ${menuOpen ? "open" : ""}`} style={{ width: 250, background: "#fff", borderRight: "1px solid rgba(107,45,139,0.08)", padding: "24px 16px", display: "flex", flexDirection: "column", position: "fixed", top: 0, left: 0, bottom: 0, zIndex: 200, overflowY: "auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 8px 28px", cursor: "pointer" }} onClick={() => window.location.href = "/"}>
          <img src="/LOGO_CD_ASSIST.png" alt="Logo" style={{ width: 50, objectFit: "contain" }} />
          <div>
            <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 14, fontWeight: 700, color: "#6B2D8B" }}>CD'ASSIST</div>
            <div style={{ fontSize: 9, color: "#C4006A", letterSpacing: 2, textTransform: "uppercase", fontWeight: 700 }}>ÉDITEUR DE SITE</div>
          </div>
        </div>
        <nav style={{ flex: 1, display: "flex", flexDirection: "column", gap: 4 }}>
          {NAV.map(n => (
            <div key={n.id}>
              <button className={`nav-btn ${page === n.id ? "active" : ""}`} onClick={() => {
                setPage(n.id); setDraft(getData()); setSaved(false); setParamsPage(null); setMenuOpen(false);
                if (["clients","declarations","messages"].includes(n.id)) loadFirebaseData(n.id);
              }}>
                <span style={{ fontSize: 16 }}>{n.icon}</span>{n.label}
              </button>
              {/* Sous-menu Paramètres */}
              {n.id === "params" && page === "params" && (
                <div style={{ marginLeft: 16, marginTop: 4, display: "flex", flexDirection: "column", gap: 2 }}>
                  {[
                    { id: "accueil", icon: "🏠", label: "Page Accueil" },
                    { id: "apropos", icon: "👩‍💼", label: "À propos" },
                    { id: "prestations", icon: "🛠️", label: "Prestations" },
                    { id: "tarifs", icon: "💰", label: "Tarifs" },
                    { id: "contact", icon: "📞", label: "Contact" },
                    { id: "theme", icon: "🎨", label: "Couleurs & Logo" },
                  ].map(p => (
                    <button key={p.id} onClick={() => { setParamsPage(p.id); setDraft(getData()); setSaved(false); }}
                      style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 12px", borderRadius: 8, fontSize: 12, fontWeight: paramsPage === p.id ? 700 : 500, cursor: "pointer", background: paramsPage === p.id ? "rgba(196,0,106,0.1)" : "transparent", color: paramsPage === p.id ? "#C4006A" : "#9B7BB8", border: "none", width: "100%", textAlign: "left" }}>
                      <span>{p.icon}</span>{p.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>
        <div style={{ borderTop: "1px solid #f3e8ff", paddingTop: 16 }}>
          <a href="/" target="_blank" style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 12px", borderRadius: 10, fontSize: 13, color: "#6B2D8B", fontWeight: 600, textDecoration: "none", marginBottom: 8 }}>👁️ Voir le site</a>
          <button onClick={handleLogout} style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 12px", borderRadius: 10, fontSize: 13, color: "#DC2626", fontWeight: 600, background: "none", border: "none", cursor: "pointer", width: "100%" }}>🚪 Se déconnecter</button>
        </div>
      </aside>

      <main className="bo-main" style={{ marginLeft: 250, flex: 1, padding: "32px 40px", overflowY: "auto" }}>

        {page === "dashboard" && (
          <div className="fade-up">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 28, flexWrap: "wrap", gap: 16 }}>
              <div>
                <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 36, color: "#1A0A2E", marginBottom: 4 }}>Bonjour Daniela 👋</h1>
                <p style={{ fontSize: 14, color: "#9B7BB8" }}>Voici un aperçu de votre activité</p>
              </div>
              <button onClick={() => setShowEnvoyerLien(true)} style={{ background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", border: "none", padding: "14px 28px", borderRadius: 50, fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: 14, cursor: "pointer", boxShadow: "0 8px 28px rgba(196,0,106,0.35)" }}>
                💳 Envoyer un lien de paiement
              </button>
            </div>

            {/* Statistiques */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(160px,1fr))", gap: 16, marginBottom: 28 }} className="stats-grid">
              {[
                { icon: "🛍️", label: "Boutique", value: "→", color: "#8B2FC9", page: "boutique_admin" },
                { icon: "👥", label: "Clients", value: stats.clients, color: "#6B2D8B", page: "clients" },
                { icon: "💬", label: "Messages", value: stats.messages, color: "#C4006A", page: "messages" },
                { icon: "🧾", label: "Déclarations", value: stats.declarations, color: "#8B2FC9", page: "declarations" },
                { icon: "📅", label: "RDV", value: stats.rdvs, color: "#C4006A", page: "rdv" },
                { icon: "✅", label: "Réglés", value: stats.reglements, color: "#059669", page: "paiements" },
                { icon: "⏳", label: "Non réglés", value: stats.nonReglements, color: "#D97706", page: "paiements" },
              ].map(s => (
                <div key={s.label} onClick={() => setPage(s.page)} style={{ background: "#fff", borderRadius: 16, padding: "20px", boxShadow: "0 2px 12px rgba(107,45,139,0.07)", cursor: "pointer", textAlign: "center", border: `1.5px solid rgba(107,45,139,0.06)`, transition: "all .3s" }}
                  onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.borderColor = s.color; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.borderColor = "rgba(107,45,139,0.06)"; }}>
                  <div style={{ fontSize: 28, marginBottom: 8 }}>{s.icon}</div>
                  <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 36, fontWeight: 700, color: s.color }}>{s.value}</div>
                  <div style={{ fontSize: 12, color: "#9B7BB8", fontWeight: 600 }}>{s.label}</div>
                </div>
              ))}
            </div>

            {/* Graphique règlements */}
            <div style={{ background: "#fff", borderRadius: 16, padding: "24px", marginBottom: 24, boxShadow: "0 2px 12px rgba(107,45,139,0.07)" }}>
              <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, color: "#1A0A2E", marginBottom: 20 }}>💰 État des règlements</h2>
              <div style={{ display: "flex", gap: 20, alignItems: "center", flexWrap: "wrap" }}>
                <div style={{ flex: 1, minWidth: 200 }}>
                  {stats.reglements + stats.nonReglements > 0 ? (
                    <div style={{ height: 24, borderRadius: 50, background: "#f3e8ff", overflow: "hidden", display: "flex" }}>
                      <div style={{ width: `${(stats.reglements / (stats.reglements + stats.nonReglements)) * 100}%`, background: "linear-gradient(135deg,#059669,#34D399)", transition: "width .5s", borderRadius: 50 }} />
                    </div>
                  ) : (
                    <div style={{ height: 24, borderRadius: 50, background: "#f3e8ff" }} />
                  )}
                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8, fontSize: 13 }}>
                    <span style={{ color: "#059669", fontWeight: 600 }}>✅ Réglés : {stats.reglements}</span>
                    <span style={{ color: "#D97706", fontWeight: 600 }}>⏳ En attente : {stats.nonReglements}</span>
                  </div>
                </div>
                <button onClick={() => setPage("paiements")} style={{ background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", border: "none", padding: "10px 20px", borderRadius: 50, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                  Voir les règlements →
                </button>
              </div>
            </div>

            {/* Activité récente */}
            <div style={{ background: "#fff", borderRadius: 16, padding: "24px", boxShadow: "0 2px 12px rgba(107,45,139,0.07)" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
                <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, color: "#1A0A2E" }}>🕐 Activité récente</h2>
                <button onClick={loadDashboard} style={{ background: "#f3e8ff", color: "#6B2D8B", border: "none", padding: "7px 16px", borderRadius: 50, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>🔄 Actualiser</button>
              </div>
              {recentActivity.length === 0 ? (
                <p style={{ color: "#9B7BB8", textAlign: "center", padding: "24px" }}>Aucune activité récente.</p>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  {recentActivity.map((a, i) => (
                    <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 16px", background: "#faf7ff", borderRadius: 10 }}>
                      <span style={{ fontSize: 20 }}>{a.icon}</span>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 14, fontWeight: 600, color: "#1A0A2E" }}>{a.label}</div>
                        <div style={{ fontSize: 12, color: "#9B7BB8" }}>{a.date?.toDate?.().toLocaleDateString("fr-FR") || "Récent"}</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {/* ── PAGE PARAMÈTRES ── */}
        {page === "params" && !paramsPage && (
          <div className="fade-up">
            <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 36, color: "#1A0A2E", marginBottom: 8 }}>⚙️ Paramètres</h1>
            <p style={{ fontSize: 14, color: "#9B7BB8", marginBottom: 28 }}>Modifiez le contenu de votre site.</p>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 20 }} className="params-grid">
              {[
                { id: "accueil", icon: "🏠", label: "Page Accueil", desc: "Slogan, description, statistiques" },
                { id: "apropos", icon: "👩‍💼", label: "À propos", desc: "Votre histoire, citation, infos" },
                { id: "prestations", icon: "🛠️", label: "Prestations", desc: "Ajouter, modifier, supprimer" },
                { id: "tarifs", icon: "💰", label: "Tarifs", desc: "Forfaits et tarifs à la carte" },
                { id: "contact", icon: "📞", label: "Contact", desc: "Téléphone, email, horaires" },
                { id: "theme", icon: "🎨", label: "Couleurs & Logo", desc: "Thème visuel du site" },
              ].map(c => (
                <div key={c.id} onClick={() => setParamsPage(c.id)} style={{ background: "#fff", borderRadius: 16, padding: "28px 24px", boxShadow: "0 2px 16px rgba(107,45,139,0.07)", cursor: "pointer", border: "1.5px solid rgba(107,45,139,0.06)", transition: "all .3s" }}
                  onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.borderColor = "#C4006A"; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.borderColor = "rgba(107,45,139,0.06)"; }}>
                  <div style={{ fontSize: 32, marginBottom: 12 }}>{c.icon}</div>
                  <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 20, color: "#1A0A2E", marginBottom: 6 }}>{c.label}</h3>
                  <p style={{ fontSize: 13, color: "#9B7BB8" }}>{c.desc}</p>
                  <div style={{ marginTop: 16, fontSize: 12, color: "#C4006A", fontWeight: 700 }}>Modifier →</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── PAGE RÈGLEMENTS ── */}
        {page === "paiements" && (
          <div className="fade-up">
            <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 36, color: "#1A0A2E", marginBottom: 8 }}>💰 Règlements</h1>
            <p style={{ fontSize: 14, color: "#9B7BB8", marginBottom: 28 }}>Suivi des paiements reçus et en attente.</p>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 28 }}>
              <div style={{ background: "rgba(16,185,129,0.08)", borderRadius: 16, padding: "24px", border: "1.5px solid rgba(16,185,129,0.2)", textAlign: "center" }}>
                <div style={{ fontSize: 36, marginBottom: 8 }}>✅</div>
                <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 48, fontWeight: 700, color: "#059669" }}>{stats.reglements}</div>
                <div style={{ fontSize: 14, color: "#059669", fontWeight: 600 }}>Règlements reçus</div>
              </div>
              <div style={{ background: "rgba(245,158,11,0.08)", borderRadius: 16, padding: "24px", border: "1.5px solid rgba(245,158,11,0.2)", textAlign: "center" }}>
                <div style={{ fontSize: 36, marginBottom: 8 }}>⏳</div>
                <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 48, fontWeight: 700, color: "#D97706" }}>{stats.nonReglements}</div>
                <div style={{ fontSize: 14, color: "#D97706", fontWeight: 600 }}>En attente de règlement</div>
              </div>
            </div>
            {paiements.length === 0 ? (
              <div style={{ background: "#fff", borderRadius: 16, padding: "48px", textAlign: "center", boxShadow: "0 2px 12px rgba(107,45,139,0.06)" }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>💰</div>
                <p style={{ color: "#9B7BB8", marginBottom: 16 }}>Aucun règlement enregistré pour le moment.</p>
                <p style={{ fontSize: 13, color: "#9B7BB8" }}>Les règlements apparaîtront ici quand vous les enregistrerez manuellement ou via SumUp/PayPal.</p>
                <button onClick={() => setShowEnvoyerLien(true)} style={{ marginTop: 20, background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", border: "none", padding: "12px 28px", borderRadius: 50, fontFamily: "'DM Sans',sans-serif", fontWeight: 700, cursor: "pointer" }}>
                  💳 Envoyer un lien de paiement
                </button>
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                {paiements.map(p => (
                  <div key={p.id} style={{ background: "#fff", borderRadius: 14, padding: "18px 24px", boxShadow: "0 2px 10px rgba(107,45,139,0.06)", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
                    <div>
                      <div style={{ fontSize: 15, fontWeight: 700, color: "#1A0A2E" }}>{p.clientNom}</div>
                      <div style={{ fontSize: 13, color: "#9B7BB8" }}>{p.service} · {p.montant}</div>
                    </div>
                    <span style={{ fontSize: 11, fontWeight: 700, padding: "4px 14px", borderRadius: 20, background: p.statut === "payé" ? "rgba(16,185,129,0.1)" : "rgba(245,158,11,0.1)", color: p.statut === "payé" ? "#059669" : "#D97706" }}>
                      {p.statut === "payé" ? "✅ Réglé" : "⏳ En attente"}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* ── PAGE BOUTIQUE ADMIN ── */}
        {page === "boutique_admin" && <BoutiqueAdmin />}

        {/* ── PAGE RDV ── */}
        {page === "rdv" && (
          <RdvManager setShowEnvoyerLien={setShowEnvoyerLien} />
        )}

        {page === "clients" && (
          <div className="fade-up">
            <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 36, color: "#1A0A2E", marginBottom: 8 }}>👥 Clients</h1>
            <p style={{ fontSize: 14, color: "#9B7BB8", marginBottom: 28 }}>Liste des clients inscrits sur l'espace client.</p>
            {loadingData ? (
              <div style={{ textAlign: "center", padding: "48px", color: "#9B7BB8" }}>Chargement...</div>
            ) : clients.length === 0 ? (
              <div style={{ background: "#fff", borderRadius: 16, padding: "48px", textAlign: "center", boxShadow: "0 2px 12px rgba(107,45,139,0.06)" }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>👥</div>
                <p style={{ color: "#9B7BB8", fontSize: 15 }}>Aucun client inscrit pour le moment.</p>
                <button onClick={() => loadFirebaseData("clients")} style={{ marginTop: 16, background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", border: "none", padding: "10px 24px", borderRadius: 50, cursor: "pointer", fontFamily: "'DM Sans',sans-serif", fontWeight: 600 }}>🔄 Actualiser</button>
              </div>
            ) : (
              <>
                <button onClick={() => loadFirebaseData("clients")} style={{ marginBottom: 20, background: "#f3e8ff", color: "#6B2D8B", border: "none", padding: "9px 20px", borderRadius: 50, cursor: "pointer", fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: 13 }}>🔄 Actualiser</button>
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  {clients.map((c, i) => (
                    <div key={i} style={{ background: "#fff", borderRadius: 14, padding: "18px 24px", boxShadow: "0 2px 10px rgba(107,45,139,0.06)", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
                      <div>
                        <div style={{ fontSize: 15, fontWeight: 700, color: "#1A0A2E" }}>{c.nom || c.email}</div>
                        <div style={{ fontSize: 13, color: "#9B7BB8", marginTop: 3 }}>✉️ {c.email}</div>
                      </div>
                      <div style={{ display: "flex", gap: 10 }}>
                        <a href={`mailto:${c.email}`} style={{ background: "#f3e8ff", color: "#6B2D8B", textDecoration: "none", padding: "8px 16px", borderRadius: 50, fontSize: 12, fontWeight: 600 }}>✉️ Email</a>
                        <button onClick={() => setShowEnvoyerLien(true)} style={{ background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", border: "none", padding: "8px 16px", borderRadius: 50, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>💳 Lien paiement</button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        )}

        {/* ── PAGE DÉCLARATIONS ── */}
        {page === "declarations" && (
          <div className="fade-up">
            <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 36, color: "#1A0A2E", marginBottom: 8 }}>🧾 Déclarations d'impôts</h1>
            <p style={{ fontSize: 14, color: "#9B7BB8", marginBottom: 28 }}>Dossiers envoyés par vos clients.</p>
            {loadingData ? (
              <div style={{ textAlign: "center", padding: "48px", color: "#9B7BB8" }}>Chargement...</div>
            ) : declarations.length === 0 ? (
              <div style={{ background: "#fff", borderRadius: 16, padding: "48px", textAlign: "center", boxShadow: "0 2px 12px rgba(107,45,139,0.06)" }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>🧾</div>
                <p style={{ color: "#9B7BB8", fontSize: 15 }}>Aucun dossier reçu pour le moment.</p>
                <button onClick={() => loadFirebaseData("declarations")} style={{ marginTop: 16, background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", border: "none", padding: "10px 24px", borderRadius: 50, cursor: "pointer", fontFamily: "'DM Sans',sans-serif", fontWeight: 600 }}>🔄 Actualiser</button>
              </div>
            ) : (
              <>
                <button onClick={() => loadFirebaseData("declarations")} style={{ marginBottom: 20, background: "#f3e8ff", color: "#6B2D8B", border: "none", padding: "9px 20px", borderRadius: 50, cursor: "pointer", fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: 13 }}>🔄 Actualiser</button>
                <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                  {declarations.map(d => (
                    <div key={d.id} style={{ background: "#fff", borderRadius: 16, padding: "24px", boxShadow: "0 2px 12px rgba(107,45,139,0.06)" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16, flexWrap: "wrap", gap: 12 }}>
                        <div>
                          <div style={{ fontSize: 16, fontWeight: 700, color: "#1A0A2E" }}>{d.userName || d.userEmail}</div>
                          <div style={{ fontSize: 13, color: "#9B7BB8", marginTop: 3 }}>✉️ {d.userEmail} · 📅 Année {d.annee}</div>
                          {d.note && <div style={{ fontSize: 13, color: "#374151", marginTop: 6, fontStyle: "italic" }}>💬 "{d.note}"</div>}
                        </div>
                        {/* Sélecteur de statut */}
                        <select
                          value={d.statut || "En attente"}
                          onChange={async (e) => {
                            const newStatut = e.target.value;
                            try {
                              const { updateDoc, doc: fDoc } = await import("firebase/firestore");
                              await updateDoc(fDoc(db, "declarations", d.id), { statut: newStatut });
                              setDeclarations(prev => prev.map(dec => dec.id === d.id ? { ...dec, statut: newStatut } : dec));
                            } catch (err) { console.error(err); }
                          }}
                          style={{
                            padding: "6px 14px", borderRadius: 20, border: "2px solid",
                            fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: 12, cursor: "pointer",
                            background: d.statut === "Traité" ? "rgba(16,185,129,0.1)" :
                              d.statut === "En cours de traitement" ? "rgba(59,130,246,0.1)" :
                              d.statut === "Dossier réceptionné" ? "rgba(139,47,201,0.1)" :
                              "rgba(245,158,11,0.1)",
                            color: d.statut === "Traité" ? "#059669" :
                              d.statut === "En cours de traitement" ? "#2563EB" :
                              d.statut === "Dossier réceptionné" ? "#6B2D8B" :
                              "#D97706",
                            borderColor: d.statut === "Traité" ? "#059669" :
                              d.statut === "En cours de traitement" ? "#2563EB" :
                              d.statut === "Dossier réceptionné" ? "#6B2D8B" :
                              "#D97706",
                          }}>
                          <option>En attente</option>
                          <option>Dossier réceptionné</option>
                          <option>En cours de traitement</option>
                          <option>Traité</option>
                        </select>
                      </div>
                      {/* Documents */}
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(200px,1fr))", gap: 10 }}>
                        {Object.entries(d.documents || {}).map(([key, doc]) => (
                          <a key={key} href={doc.url} target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: "#faf7ff", borderRadius: 10, textDecoration: "none", border: "1px solid rgba(196,0,106,0.1)" }}>
                            <span style={{ fontSize: 18 }}>📄</span>
                            <span style={{ fontSize: 12, color: "#374151", fontWeight: 500, flex: 1 }}>{doc.nom}</span>
                            <a href={doc.url} download={doc.nom} onClick={e => e.stopPropagation()} style={{ background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", textDecoration: "none", padding: "4px 10px", borderRadius: 20, fontSize: 11, fontWeight: 600 }}>⬇️</a>
                          </a>
                        ))}
                      </div>
                      <div style={{ marginTop: 14, display: "flex", gap: 10 }}>
                        <a href={`mailto:${d.userEmail}`} style={{ background: "#f3e8ff", color: "#6B2D8B", textDecoration: "none", padding: "8px 18px", borderRadius: 50, fontSize: 12, fontWeight: 600 }}>✉️ Contacter</a>
                        <button onClick={() => setShowEnvoyerLien(true)} style={{ background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", border: "none", padding: "8px 18px", borderRadius: 50, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>💳 Envoyer lien paiement</button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        )}

        {/* ── PAGE MESSAGES ── */}
        {page === "messages" && (
          <div className="fade-up">
            <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 36, color: "#1A0A2E", marginBottom: 8 }}>💬 Messages clients</h1>
            <p style={{ fontSize: 14, color: "#9B7BB8", marginBottom: 28 }}>Messages reçus de vos clients via l'espace client.</p>
            {loadingData ? (
              <div style={{ textAlign: "center", padding: "48px", color: "#9B7BB8" }}>Chargement...</div>
            ) : messagesClients.length === 0 ? (
              <div style={{ background: "#fff", borderRadius: 16, padding: "48px", textAlign: "center", boxShadow: "0 2px 12px rgba(107,45,139,0.06)" }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>💬</div>
                <p style={{ color: "#9B7BB8", fontSize: 15 }}>Aucun message reçu pour le moment.</p>
                <button onClick={() => loadFirebaseData("messages")} style={{ marginTop: 16, background: "linear-gradient(135deg,#C4006A,#8B2FC9)", color: "#fff", border: "none", padding: "10px 24px", borderRadius: 50, cursor: "pointer", fontFamily: "'DM Sans',sans-serif", fontWeight: 600 }}>🔄 Actualiser</button>
              </div>
            ) : (
              <>
                <button onClick={() => loadFirebaseData("messages")} style={{ marginBottom: 20, background: "#f3e8ff", color: "#6B2D8B", border: "none", padding: "9px 20px", borderRadius: 50, cursor: "pointer", fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: 13 }}>🔄 Actualiser</button>
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  {messagesClients.map(m => (
                    <MessageCard key={m.id} m={m} onDelete={async () => {
                      if (!window.confirm("Supprimer ce message ?")) return;
                      const { deleteDoc, doc: fDoc } = await import("firebase/firestore");
                      await deleteDoc(fDoc(db, "messages", m.id));
                      loadFirebaseData("messages");
                    }} db={db} />
                  ))}
                </div>
              </>
            )}
          </div>
        )}

        {page === "params" && paramsPage === "accueil" && (
          <div className="fade-up">
            <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 36, color: "#1A0A2E", marginBottom: 8 }}>🏠 Page Accueil</h1>
            <p style={{ fontSize: 14, color: "#9B7BB8", marginBottom: 24 }}>Modifiez les textes principaux de votre page d'accueil.</p>
            <SaveBar onSave={handleSave} onReset={handleReset} saved={saved} />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
              <div className="card">
                <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, color: "#1A0A2E", marginBottom: 20 }}>Textes principaux</h3>
                <Field label="Tag d'introduction" value={draft.accueil.tag} onChange={v => setDraft({ ...draft, accueil: { ...draft.accueil, tag: v } })} hint="Texte affiché au-dessus du titre" />
                <Field label="Titre principal" value={draft.accueil.titre} onChange={v => setDraft({ ...draft, accueil: { ...draft.accueil, titre: v } })} />
                <Field label="Description" value={draft.accueil.description} onChange={v => setDraft({ ...draft, accueil: { ...draft.accueil, description: v } })} multiline />
                <Field label="Texte bouton 1" value={draft.accueil.bouton1} onChange={v => setDraft({ ...draft, accueil: { ...draft.accueil, bouton1: v } })} />
                <Field label="Texte bouton 2" value={draft.accueil.bouton2} onChange={v => setDraft({ ...draft, accueil: { ...draft.accueil, bouton2: v } })} />
              </div>
              <div className="card">
                <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, color: "#1A0A2E", marginBottom: 20 }}>Statistiques</h3>
                {[
                  { valKey: "stat1_valeur", labKey: "stat1_label", num: "1" },
                  { valKey: "stat2_valeur", labKey: "stat2_label", num: "2" },
                  { valKey: "stat3_valeur", labKey: "stat3_label", num: "3" },
                ].map(s => (
                  <div key={s.num} style={{ background: "#faf7ff", borderRadius: 12, padding: 16, marginBottom: 16 }}>
                    <p style={{ fontSize: 12, fontWeight: 700, color: "#C4006A", letterSpacing: 1, textTransform: "uppercase", marginBottom: 10 }}>Statistique {s.num}</p>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                      <Field label="Valeur" value={draft.accueil[s.valKey]} onChange={v => setDraft({ ...draft, accueil: { ...draft.accueil, [s.valKey]: v } })} />
                      <Field label="Label" value={draft.accueil[s.labKey]} onChange={v => setDraft({ ...draft, accueil: { ...draft.accueil, [s.labKey]: v } })} />
                    </div>
                  </div>
                ))}
                <div style={{ background: "linear-gradient(135deg,#faf7ff,#fff0f7)", borderRadius: 12, padding: 20, border: "1.5px solid rgba(107,45,139,0.08)" }}>
                  <p style={{ fontSize: 11, fontWeight: 700, color: "#9B7BB8", letterSpacing: 1, textTransform: "uppercase", marginBottom: 12 }}>Aperçu</p>
                  <div style={{ display: "inline-block", background: "rgba(196,0,106,0.1)", color: "#C4006A", padding: "4px 14px", borderRadius: 20, fontSize: 11, fontWeight: 700, marginBottom: 12 }}>{draft.accueil.tag}</div>
                  <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, color: "#1A0A2E", marginBottom: 8 }}>{draft.accueil.titre}</h2>
                  <p style={{ fontSize: 13, color: "#6B7280" }}>{draft.accueil.description}</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {page === "params" && paramsPage === "apropos" && (
          <div className="fade-up">
            <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 36, color: "#1A0A2E", marginBottom: 8 }}>👩‍💼 Page À propos</h1>
            <p style={{ fontSize: 14, color: "#9B7BB8", marginBottom: 24 }}>Modifiez votre histoire et vos informations.</p>
            <SaveBar onSave={handleSave} onReset={handleReset} saved={saved} />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
              <div className="card">
                <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, color: "#1A0A2E", marginBottom: 20 }}>Votre histoire</h3>
                <Field label="Titre" value={draft.apropos.titre} onChange={v => setDraft({ ...draft, apropos: { ...draft.apropos, titre: v } })} />
                <Field label="Paragraphe 1" value={draft.apropos.paragraphe1} onChange={v => setDraft({ ...draft, apropos: { ...draft.apropos, paragraphe1: v } })} multiline />
                <Field label="Paragraphe 2" value={draft.apropos.paragraphe2} onChange={v => setDraft({ ...draft, apropos: { ...draft.apropos, paragraphe2: v } })} multiline />
                <Field label="Paragraphe 3" value={draft.apropos.paragraphe3} onChange={v => setDraft({ ...draft, apropos: { ...draft.apropos, paragraphe3: v } })} multiline />
              </div>
              <div className="card">
                <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, color: "#1A0A2E", marginBottom: 20 }}>Citation & Infos</h3>
                <Field label="Votre citation" value={draft.apropos.citation} onChange={v => setDraft({ ...draft, apropos: { ...draft.apropos, citation: v } })} multiline hint="Apparaît dans le bloc violet" />
                <Field label="Votre poste" value={draft.apropos.poste} onChange={v => setDraft({ ...draft, apropos: { ...draft.apropos, poste: v } })} />
                <Field label="Localisation" value={draft.apropos.localisation} onChange={v => setDraft({ ...draft, apropos: { ...draft.apropos, localisation: v } })} />
                <div style={{ background: "linear-gradient(135deg,#6B2D8B,#C4006A)", borderRadius: 12, padding: 20, color: "#fff", marginTop: 8 }}>
                  <p style={{ fontSize: 14, lineHeight: 1.8, fontStyle: "italic" }}>« {draft.apropos.citation} »</p>
                  <div style={{ marginTop: 12, fontSize: 13, fontWeight: 700 }}>— Cordinel Daniela</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {page === "params" && paramsPage === "prestations" && (
          <div className="fade-up">
            <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 36, color: "#1A0A2E", marginBottom: 8 }}>🛠️ Prestations</h1>
            <p style={{ fontSize: 14, color: "#9B7BB8", marginBottom: 24 }}>Ajoutez, modifiez ou supprimez vos prestations.</p>
            <SaveBar onSave={handleSave} onReset={handleReset} saved={saved} />
            <div className="card">
              {draft.prestations.map((p, i) => (
                <div key={p.id} style={{ background: "#faf7ff", borderRadius: 12, padding: 20, marginBottom: 12, border: "1.5px solid rgba(107,45,139,0.08)" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
                    <span style={{ fontSize: 13, fontWeight: 700, color: "#6B2D8B" }}>Prestation {i + 1} — {p.icon} {p.titre}</span>
                    <button className="delete-btn" onClick={() => setDraft({ ...draft, prestations: draft.prestations.filter(x => x.id !== p.id) })}>🗑️ Supprimer</button>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "80px 1fr 1fr", gap: 12 }}>
                    <Field label="Icône" value={p.icon} onChange={v => setDraft({ ...draft, prestations: draft.prestations.map(x => x.id === p.id ? { ...x, icon: v } : x) })} hint="Emoji" />
                    <Field label="Titre" value={p.titre} onChange={v => setDraft({ ...draft, prestations: draft.prestations.map(x => x.id === p.id ? { ...x, titre: v } : x) })} />
                    <Field label="Prix" value={p.prix} onChange={v => setDraft({ ...draft, prestations: draft.prestations.map(x => x.id === p.id ? { ...x, prix: v } : x) })} />
                  </div>
                  <Field label="Description" value={p.description} onChange={v => setDraft({ ...draft, prestations: draft.prestations.map(x => x.id === p.id ? { ...x, description: v } : x) })} multiline />
                </div>
              ))}
              <button className="add-btn" onClick={() => setDraft({ ...draft, prestations: [...draft.prestations, { id: Date.now(), icon: "⭐", titre: "Nouvelle prestation", description: "Description de la prestation", prix: "Sur devis" }] })}>
                + Ajouter une prestation
              </button>
            </div>
          </div>
        )}

        {page === "params" && paramsPage === "tarifs" && (
          <div className="fade-up">
            <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 36, color: "#1A0A2E", marginBottom: 8 }}>💰 Tarifs</h1>
            <p style={{ fontSize: 14, color: "#9B7BB8", marginBottom: 24 }}>Modifiez vos forfaits et tarifs à la carte.</p>
            <SaveBar onSave={handleSave} onReset={handleReset} saved={saved} />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
              <div className="card">
                <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, color: "#1A0A2E", marginBottom: 20 }}>Forfaits mensuels</h3>
                {draft.tarifs.forfaits.map(f => (
                  <div key={f.id} style={{ background: "#faf7ff", borderRadius: 12, padding: 16, marginBottom: 12, border: f.populaire ? "2px solid #C4006A" : "1.5px solid rgba(107,45,139,0.08)" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                      <span style={{ fontSize: 13, fontWeight: 700, color: "#6B2D8B" }}>{f.nom}</span>
                      <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: "#9B7BB8", cursor: "pointer" }}>
                        <input type="checkbox" checked={f.populaire} onChange={e => setDraft({ ...draft, tarifs: { ...draft.tarifs, forfaits: draft.tarifs.forfaits.map(x => x.id === f.id ? { ...x, populaire: e.target.checked } : x) } })} />
                        ⭐ Populaire
                      </label>
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
                      <Field label="Nom" value={f.nom} onChange={v => setDraft({ ...draft, tarifs: { ...draft.tarifs, forfaits: draft.tarifs.forfaits.map(x => x.id === f.id ? { ...x, nom: v } : x) } })} />
                      <Field label="Prix (€)" value={f.prix} onChange={v => setDraft({ ...draft, tarifs: { ...draft.tarifs, forfaits: draft.tarifs.forfaits.map(x => x.id === f.id ? { ...x, prix: v } : x) } })} />
                      <Field label="Heures" value={f.heures} onChange={v => setDraft({ ...draft, tarifs: { ...draft.tarifs, forfaits: draft.tarifs.forfaits.map(x => x.id === f.id ? { ...x, heures: v } : x) } })} />
                    </div>
                  </div>
                ))}
              </div>
              <div className="card">
                <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, color: "#1A0A2E", marginBottom: 20 }}>Tarifs à la carte</h3>
                {draft.tarifs.alacarte.map(t => (
                  <div key={t.id} style={{ background: "#faf7ff", borderRadius: 10, padding: "12px 14px", marginBottom: 10 }}>
                    <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                      <div style={{ flex: 1 }}>
                        <Field label="Libellé" value={t.label} onChange={v => setDraft({ ...draft, tarifs: { ...draft.tarifs, alacarte: draft.tarifs.alacarte.map(x => x.id === t.id ? { ...x, label: v } : x) } })} />
                        <Field label="Prix" value={t.prix} onChange={v => setDraft({ ...draft, tarifs: { ...draft.tarifs, alacarte: draft.tarifs.alacarte.map(x => x.id === t.id ? { ...x, prix: v } : x) } })} />
                      </div>
                      <button className="delete-btn" onClick={() => setDraft({ ...draft, tarifs: { ...draft.tarifs, alacarte: draft.tarifs.alacarte.filter(x => x.id !== t.id) } })} style={{ marginTop: 24 }}>🗑️</button>
                    </div>
                  </div>
                ))}
                <button className="add-btn" onClick={() => setDraft({ ...draft, tarifs: { ...draft.tarifs, alacarte: [...draft.tarifs.alacarte, { id: Date.now(), label: "Nouveau service", prix: "Sur devis" }] } })}>
                  + Ajouter un tarif
                </button>
              </div>
            </div>
          </div>
        )}

        {page === "params" && paramsPage === "contact" && (
          <div className="fade-up">
            <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 36, color: "#1A0A2E", marginBottom: 8 }}>📞 Contact</h1>
            <p style={{ fontSize: 14, color: "#9B7BB8", marginBottom: 24 }}>Modifiez vos coordonnées affichées sur le site.</p>
            <SaveBar onSave={handleSave} onReset={handleReset} saved={saved} />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
              <div className="card">
                <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, color: "#1A0A2E", marginBottom: 20 }}>Coordonnées</h3>
                <Field label="Téléphone principal" value={draft.contact.telephone1} onChange={v => setDraft({ ...draft, contact: { ...draft.contact, telephone1: v } })} />
                <Field label="Téléphone secondaire" value={draft.contact.telephone2} onChange={v => setDraft({ ...draft, contact: { ...draft.contact, telephone2: v } })} />
                <Field label="Email" value={draft.contact.email} onChange={v => setDraft({ ...draft, contact: { ...draft.contact, email: v } })} type="email" />
                <Field label="Adresse" value={draft.contact.adresse} onChange={v => setDraft({ ...draft, contact: { ...draft.contact, adresse: v } })} />
                <Field label="Horaires" value={draft.contact.horaires} onChange={v => setDraft({ ...draft, contact: { ...draft.contact, horaires: v } })} hint="Ex: Lun–Ven · 9h–18h" />
                <Field label="Site web" value={draft.contact.site} onChange={v => setDraft({ ...draft, contact: { ...draft.contact, site: v } })} />
              </div>
              <div className="card">
                <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, color: "#1A0A2E", marginBottom: 20 }}>Aperçu</h3>
                {[
                  { icon: "📞", label: "Téléphones", value: `${draft.contact.telephone1} · ${draft.contact.telephone2}` },
                  { icon: "✉️", label: "Email", value: draft.contact.email },
                  { icon: "📍", label: "Adresse", value: draft.contact.adresse },
                  { icon: "🕐", label: "Horaires", value: draft.contact.horaires },
                  { icon: "🌐", label: "Site", value: draft.contact.site },
                ].map(c => (
                  <div key={c.label} style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px 0", borderBottom: "1px solid #f3e8ff" }}>
                    <span style={{ fontSize: 24 }}>{c.icon}</span>
                    <div>
                      <div style={{ fontSize: 11, fontWeight: 700, color: "#C4006A", letterSpacing: 1, textTransform: "uppercase" }}>{c.label}</div>
                      <div style={{ fontSize: 14, color: "#1A0A2E", fontWeight: 500 }}>{c.value}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {page === "params" && paramsPage === "theme" && (
          <div className="fade-up">
            <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 36, color: "#1A0A2E", marginBottom: 8 }}>🎨 Couleurs & Logo</h1>
            <p style={{ fontSize: 14, color: "#9B7BB8", marginBottom: 24 }}>Personnalisez l'apparence visuelle de votre site.</p>
            <SaveBar onSave={handleSave} onReset={handleReset} saved={saved} />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
              <div className="card">
                <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, color: "#1A0A2E", marginBottom: 20 }}>Couleurs</h3>
                {[
                  { key: "couleur1", label: "Couleur principale", desc: "Boutons, accents, liens actifs" },
                  { key: "couleur2", label: "Couleur secondaire", desc: "Titres, navbar, logo texte" },
                ].map(c => (
                  <div key={c.key} style={{ marginBottom: 28 }}>
                    <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#1A0A2E", marginBottom: 4 }}>{c.label}</label>
                    <p style={{ fontSize: 12, color: "#9B7BB8", marginBottom: 10 }}>{c.desc}</p>
                    <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                      <input type="color" value={draft.theme[c.key]} onChange={e => setDraft({ ...draft, theme: { ...draft.theme, [c.key]: e.target.value } })}
                        style={{ width: 56, height: 56, borderRadius: 10, border: "1.5px solid #e5d5f5", cursor: "pointer", padding: 2 }} />
                      <div style={{ width: 100, height: 44, borderRadius: 8, background: draft.theme[c.key] }} />
                      <span style={{ fontSize: 13, color: "#6B7280", fontFamily: "monospace" }}>{draft.theme[c.key]}</span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="card">
                <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, color: "#1A0A2E", marginBottom: 20 }}>Aperçu du thème</h3>
                <div style={{ background: "#faf7ff", borderRadius: 12, padding: 24, marginBottom: 20 }}>
                  <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 26, color: "#1A0A2E", marginBottom: 12 }}>
                    Votre <span style={{ color: draft.theme.couleur1 }}>assistante</span> de confiance
                  </h2>
                  <div style={{ display: "flex", gap: 12 }}>
                    <button style={{ background: `linear-gradient(135deg,${draft.theme.couleur1},${draft.theme.couleur2})`, color: "#fff", border: "none", padding: "10px 20px", borderRadius: 50, fontSize: 13, fontWeight: 700, cursor: "pointer" }}>Prendre RDV</button>
                    <button style={{ background: "transparent", color: draft.theme.couleur2, border: `2px solid ${draft.theme.couleur2}`, padding: "10px 20px", borderRadius: 50, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Documents IA</button>
                  </div>
                </div>
                <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 20, color: "#1A0A2E", marginBottom: 12 }}>Logo actuel</h3>
                <img src="/LOGO_CD_ASSIST.png" alt="Logo" style={{ width: 120, objectFit: "contain", display: "block", marginBottom: 12 }} />
                <div style={{ padding: 14, background: "rgba(196,0,106,0.05)", borderRadius: 10, border: "1px solid rgba(196,0,106,0.15)" }}>
                  <p style={{ fontSize: 12, color: "#6B7280", lineHeight: 1.6 }}>💡 Pour changer le logo, remplacez le fichier <strong>LOGO_CD_ASSIST.png</strong> dans le dossier <strong>public</strong> de votre projet, puis relancez <strong>npm run build</strong> et <strong>firebase deploy</strong>.</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}